import { transition, trigger, useAnimation } from '@angular/animations';
import { Component, input, ChangeDetectionStrategy } from '@angular/core';

import { pulseUpdate } from '../../../../shared/animations/pulse.animation';
import { MediaStateChangedEvent } from '../../../../shared/events/media-state-changed.event';

@Component({
  selector: 'era-media-state',
  templateUrl: './media-state.component.html',
  styleUrls: ['./media-state.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  animations: [trigger('pulse', [transition('* => *', [useAnimation(pulseUpdate)])])],
})
export class MediaStateComponent {
  readonly mediaState = input.required<MediaStateChangedEvent>();
}
